import React from 'react'
import Doctorform from '../Component/Doctorform'
import { Box, Toolbar, Typography } from '@mui/material'
import { useLanguage } from '../context/LanguageContext';
import Header from "../Component/header";
import DesktopFooter from "../Component/Desktopfooter";

const Doctorpage = () => {
   const { t } = useLanguage();
  return (
    <>
    <div className='textwrapper'>
     <Header/>
    </div>
    <Box>
      <Toolbar>
        <Doctorform />
      </Toolbar>
    </Box>
     <DesktopFooter/>
    </>
  )
}

export default Doctorpage
